import { joinClassNames } from '../../../../utils/styles'
import styles from './metadata.module.scss'

interface IMetadataProps {
    date: number
    intent?: {
        confidence: number
        name: string
    }
    className?: string
}

function Metadata(props: IMetadataProps) {
    const { date, className, intent } = props

    const formatedData = new Date(date).toLocaleString()

    return (
        <div
            className={joinClassNames(styles.metadata, className && className)}
        >
            <div>
                <p>{formatedData}</p>
                {intent ? (
                    <div>
                        <p>Intent: {intent.name}</p>
                        <p>
                            Confidence: {Math.round(intent.confidence * 100)}%
                        </p>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default Metadata
